import * as Sentry from '@sentry/browser';

function logError(message, info = {}, severity = Sentry.Severity.Fatal) {
  // Throw and catch error to get a stack trace
  try {
    throw new Error(message);
  } catch (e) {
    console.error(e);
    Sentry.withScope(scope => {
      scope.setLevel(severity);
      scope.setExtras(info);
      Sentry.captureException(e);
    });
  }
}

export { logError };
